
  import * as sanityRuntime$_2_45sJITvJIcFBwRSVTTCWEvna69BKBOOk4XSBlbCxrZI from '/vercel/path0/aum-website/node_modules/@nuxt/image/dist/runtime/providers/sanity'
import * as ipxRuntime$YYGnad5ru_45oHNH8YIcjyWG_45578GX_45dI1tgeOn87Pue0 from '/vercel/path0/aum-website/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536,
    "xsmall": 700,
    "medium": 1000,
    "xlarge": 1699
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "aum-two.vercel.app",
    "cdn.sanity.io"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['sanity']: { provider: sanityRuntime$_2_45sJITvJIcFBwRSVTTCWEvna69BKBOOk4XSBlbCxrZI, defaults: {"projectId":"o6jfqk87"} },
  ['ipx']: { provider: ipxRuntime$YYGnad5ru_45oHNH8YIcjyWG_45578GX_45dI1tgeOn87Pue0, defaults: {} }
    }
  }
